import React, { useEffect, useState } from "react"
import { Card, Col, Row, Spinner } from "reactstrap"
import {
  getBookings,
  getBookingCalendars,
  openCreateBookingModal,
} from "store/actions"
import { connect } from "react-redux"
import { SaveButton } from "components/Buttons"
import Select from "react-select"
import Calendar from "components/Calendar"
import FilterContainer from "./FilterContainer"
import ModalComponent from "components/Modals"
import { TIME_FORMATS } from "constants/index"
import BookingDetailModal from "./bookingDetailModal"
import CreateBookingForm from "./createBookingForm"
import CancelBookingForm from "./cancelBookingForm"
import RefundBookingForm from "./refundBookingForm"

const ScheduledEventTab = ({
  calendars,
  bookings,
  getBookings,
  businessUnits,
  bookingsAreLoading,
  getBookingCalendars,
  tabIsActive,
  openCreateBookingModal,
}) => {
  const moment = require("moment-timezone")


  
  const [selectedBusinesUnit, setSelectedBusinessUnit] = useState({
    value: null,
    label: "Global",
  })

  const [bookingDetailModalIsOpen, setBookingDetailModalIsOpen] =
    useState(false)
  const [bookingDetails, setBookingDetails] = useState(null)
  const [bookingFormIsOpen, setBookingFormIsOpen] = useState(false)
  const [cancelBookingModalIsOpen, setCancelBookingModalIsOpen] =
    useState(false)
  const [refundBookingModalIsOpen, setRefundBookingModalIsOpen] =
    useState(false)

  useEffect(() => {
    if (calendars?.length > 0) {
      getBookings({
        calendar_ids: calendars?.map(calendar => calendar?.id)?.toString(),
      })
    }
  }, [calendars])

  const onEventClick = info => {
    setBookingDetails(info?.event?.extendedProps)
    setBookingDetailModalIsOpen(true)
  }

  const editBookingHandler = () => {
    setBookingDetailModalIsOpen(false)
    setBookingFormIsOpen(true)
  }

  return (
    <React.Fragment>
      <Row className="mt-3 d-flex justify-content-between">
        <Col xs="auto">
          {businessUnits && businessUnits?.length > 0 && (
            <Row>
              <Col xs="auto" className="mt-2">
                <label>Business Unit: </label>
              </Col>
              <Col xs="auto">
                <div style={{ width: "280px" }}>
                  <Select
                    value={selectedBusinesUnit}
                    onChange={v => {
                      setSelectedBusinessUnit(v)
                      getBookingCalendars({
                        type: 2,
                        business_unit_id: v?.value,
                      })
                    }}
                    options={[
                      { value: null, label: "Global" },
                      ...businessUnits?.map(bu => ({
                        value: bu?.id,
                        label: bu?.name,
                      })),
                    ]}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: provided => ({ ...provided, zIndex: 9999 }),
                      menu: provided => ({ ...provided, zIndex: 9999 }),
                    }}
                  />
                </div>
              </Col>
            </Row>
          )}
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Add Booking"
            onClick={openCreateBookingModal}
          />
        </Col>
      </Row>
      {bookingsAreLoading && (
        <Row className="d-flex justify-content-center">
          <Col xs="auto">
            <Spinner color="danger" />
          </Col>
        </Row>
      )}
      <Row className="mt-3 d-flex justify-content-center">
        <Col xs="auto" className="mt-2">
          <label>Timezone: </label>
          <span> {moment?.tz?.guess()}</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <Calendar
            events={
              calendars?.length === 0
                ? []
                : bookings?.map(booking => ({
                    title: booking?.booking_type?.name,
                    start: new Date(
                      booking?.start_date_utc + " UTC"
                    )?.toISOString(),
                    end: moment
                      .tz(
                        booking?.end_date_object?.date,
                        booking?.end_date_object?.timezone
                      )
                      ?.toISOString(),
                    color: booking?.booking_type?.calendar?.color,
                    extendedProps: booking,
                  }))
            }
            updateSize={tabIsActive}
            // filterComponent={<FilterContainer />}
            timeZone={moment.tz.guess()}
            onEventClick={onEventClick}
          />
        </Col>
      </Row>
      <ModalComponent
        open={bookingDetailModalIsOpen}
        onClose={() => {
          setBookingDetailModalIsOpen(false)
        }}
        title="View Booking"
      >
        {!!bookingDetails && (
          <BookingDetailModal
            bookingDetails={bookingDetails}
            editBookingHandler={editBookingHandler}
            cancelBookingHandler={() => {
              setBookingDetailModalIsOpen(false)
              setCancelBookingModalIsOpen(true)
            }}
            refundBookingHandler={() => {
              setBookingDetailModalIsOpen(false)
              setRefundBookingModalIsOpen(true)
            }}
          />
        )}
      </ModalComponent>
      <ModalComponent
        open={bookingFormIsOpen}
        onClose={() => setBookingFormIsOpen(false)}
        title="Edit Booking"
        size="xl"
        style={{ maxWidth: "800px" }}
      >
        <CreateBookingForm
          isEditMode={true}
          initialValues={{
            calendar: bookingDetails?.booking_type?.calendar?.id,
            subCalendar: bookingDetails?.booking_type?.id,
            date: bookingDetails?.start_date?.split(" ")[0],
            hour:
              bookingDetails?.start_date?.split(" ")[1]?.split(":")[0] % 12 ||
              12,
            minute: bookingDetails?.start_date?.split(" ")[1]?.split(":")[1],
            timeType:
              bookingDetails?.start_date?.split(" ")[1]?.split(":")[0] < 12
                ? "AM"
                : "PM",
            timezone: bookingDetails?.timezone,
            name: bookingDetails?.user_name,
            email: bookingDetails?.user_email,
            notes: bookingDetails?.notes,
            bookedSeats: bookingDetails?.booked_seats,
            phone: bookingDetails?.phone,
          }}
          setBookingCalendar={() => {}}
          setBookingSubCalendar={() => {}}
          initialCalendarId={bookingDetails?.booking_type?.calendar?.id}
          selectedBooking={bookingDetails}
          hideEditModal={() => setBookingFormIsOpen(false)}
        />
      </ModalComponent>
      <ModalComponent
        open={cancelBookingModalIsOpen}
        onClose={() => {
          setCancelBookingModalIsOpen(false)
        }}
        title="Cancel Booking"
        size="md"
      >
        <CancelBookingForm
          booking={bookingDetails}
          onClose={() => {
            setCancelBookingModalIsOpen(false)
          }}
        />
      </ModalComponent>
      <ModalComponent
        open={refundBookingModalIsOpen}
        onClose={() => {
          setRefundBookingModalIsOpen(false)
        }}
        title="Refund Booking"
        size="md"
      >
        <RefundBookingForm
          booking={bookingDetails}
          onClose={() => {
            setRefundBookingModalIsOpen(false)
          }}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  calendars: state.BookingsFeature.calendars,
  bookings: state.BookingsFeature.bookings,
  businessUnits: state.businessUnits.businessUnits,
  bookingsAreLoading: state.BookingsFeature.bookingsAreLoading,
})

const mapDispatchToProps = dispatch => ({
  getBookings: values => dispatch(getBookings(values)),
  getBookingCalendars: values => dispatch(getBookingCalendars(values)),
  openCreateBookingModal: () => dispatch(openCreateBookingModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledEventTab)
